/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Accepter et continuer',
    APPROVE: 'Approuver',
    CANCEL: 'Annuler',
    SAVE: 'Sauvegarder'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'J\'ai lu et j\'accepte les Conditions Générales',
    ACCEPT_TERMS_DESCRIPTION:
      'Avant d\'accéder à la plateforme Prozis Partnership, veuillez consulter et accepter les Conditions Générales du programme Prozis Influencer.',
    ACCEPT_TERMS_NAV_TITLE: 'Conditions Générales',
    ACCEPT_TERMS_SCROLL_HINT: 'Veuillez lire jusqu\'à la fin pour continuer.',
    DASHBOARD: 'Tableau de bord',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Nous avons remarqué que vous n\'avez pas de notifications actives, pour pouvoir continuer à utiliser l\'application, nous avons besoin que vous activiez les notifications.',
    ENABLE_NOTIFICATIONS_LINK: 'Vous pouvez activer les notifications ici',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Notifications',
    ENABLE_NOTIFICATIONS_TITLE:
      'Activez les notifications pour pouvoir continuer',
    HOME: 'Accueil',
    INSTALL_PROZIS_APP: 'Installer l\'application Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Installez notre application mobile pour continuer à accéder à toutes les fonctionnalités.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Installer l\'application',
    LOGOUT: 'Déconnexion',
    NOT_FOUND: 'Aucun résultat',
    OR: 'Ou',
    OR_SCAN_QR_CODE: 'Ou scannez le code QR',
    SCAN_QR_CODE: 'Scannez le code QR avec votre appareil mobile',
    TODOS: 'Tous',
    UNAUTHORIZED_DESCRIPTION_1:
      'Vérifiez auprès de votre gestionnaire pour les autorisations d\'accès.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Après vérification, essayez de vous reconnecter.',
    UNAUTHORIZED_NAV_TITLE: 'Accès refusé',
    UNAUTHORIZED_TITLE: 'Aucune autorisation d\'accès'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
